(() => {
  const KEY = 'cart_countdown_end';
  let interval = null;
  let observer = null;
  let debounceTimer = null;

  function log(...a) {
    console.log('[CART TIMER]', ...a);
  }

  function getEls() {
    return {
      wrapper: document.getElementById('cart-countdown-wrapper'),
      timers: document.querySelectorAll('.cart-countdown-timer')
    };
  }

  function clearTimer() {
    if (interval) { clearInterval(interval); interval = null; }
  }

  function init(src) {
    const { wrapper, timers } = getEls();
    if (!wrapper || !timers.length) {
      log('elements not found:', src);
      return false;
    }

    const minutes = parseInt(wrapper.dataset.minutes, 10) || 15;
    const duration = minutes * 60 * 1000;

    let endTime = Number(localStorage.getItem(KEY));
    const isValid = endTime && !isNaN(endTime) && endTime > Date.now();

    if (!isValid) {
      endTime = Date.now() + duration;
      localStorage.setItem(KEY, String(endTime));
      log('new timer:', src);
    } else {
      log('resuming:', src, Math.floor((endTime - Date.now()) / 1000), 's left');
    }

    clearTimer();

    function update() {
      const saved = Number(localStorage.getItem(KEY));
      const remaining = saved - Date.now();

      if (remaining <= 0) {
        clearTimer();
        getEls().timers.forEach(el => el.textContent = '00:00');
        wrapper.classList.add('cart-countdown--expired');
        return;
      }

      const m = Math.floor(remaining / 60000);
      const s = Math.floor((remaining % 60000) / 1000);
      const time = String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      // ✅ প্রতিবার fresh querySelector — drawer re-render হলেও কাজ করবে
      document.querySelectorAll('.cart-countdown-timer').forEach(el => {
        el.textContent = time;
      });
    }

    update();
    interval = setInterval(update, 1000);
    log('running');
    return true;
  }

  function watchForElement() {
    if (observer) observer.disconnect();
    observer = new MutationObserver(() => {
      const { wrapper, timers } = getEls();
      if (wrapper && timers.length) {
        observer.disconnect();
        observer = null;
        init('mutation-observer');
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function safeInit(src) {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      const ok = init(src);
      if (!ok) watchForElement();
    }, 200);
  }

  // ✅ Events
  document.addEventListener('DOMContentLoaded', () => safeInit('DOMContentLoaded'));
  document.addEventListener('drawer:open', () => safeInit('drawer:open'));
  document.addEventListener('cart:updated', () => safeInit('cart:updated'));

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    safeInit('immediate');
  }
})();